// profile related unstable prefixes
// don't import this file directly, import '$unstable/prefixes'

/**
 * unstable prefix for profile pronouns
 */
export const MATRIX_UNSTABLE_PROFILE_PRONOUNS_PROPERTY_NAME = 'io.fsky.nyx.pronouns';

/**
 * unstable prefix for profile biography
 * defined in MSC4440 https://github.com/matrix-org/matrix-spec-proposals/pull/4440
 */
export const MATRIX_UNSTABLE_PROFILE_BIOGRAPHY_PROPERTY_NAME = 'gay.fomx.biography';

export const MATRIX_UNSTABLE_PROFILE_TIMEZONE_PROPERTY_NAME = 'us.cloke.msc4175.tz';
export const MATRIX_STABLE_PROFILE_TIMEZONE_PROPERTY_NAME = 'm.tz';

/**
 * Unstable feature and query parameter names for MSC4466 profile change propagation.
 */
export const MATRIX_UNSTABLE_MSC4466_FEATURE = 'computer.gingershaped.msc4466';
export const MATRIX_UNSTABLE_MSC4466_PROPAGATE_TO = 'computer.gingershaped.msc4466.propagate_to';

/**
 *  Unstable prefix for username colors. defined in https://github.com/matrix-org/matrix-spec-proposals/pull/4522
 */
export const MATRIX_UNSTABLE_COLORS = 'eu.she-a.color';

export const MATRIX_SABLE_UNSTABLE_MSC4461_TRIGGER_SUFFIX_PROPERTY_NAME = 'net.f0rest.suffix';
export const MATRIX_SABLE_UNSTABLE_MSC4461_TRIGGER_CIRCUMFIX_PROPERTY_NAME = 'net.f0rest.circumfix';

/** Unstable prefix for pluralkit imports */
export const MATRIX_UNSTABLE_PROFILE_PKIT_IMPORT_PROPERTY_NAME = 'net.f0rest.pkimport';
